    export class ActionConfirmation {
    Id: number;
    clase: string;
    title: string;
    icon: string;
    message: string;

    constructor(Id: number, clase: string, icon: string, title: string, message: string) {
      this.Id = Id;
      this.clase = clase;
      this.title = title;
      this.icon = icon;
      this.message = message;
    }
}
